import { graphql, readInlineData } from "react-relay";

import { paywall } from "shared/data";
import { notEmpty } from "shared/lib/utils";

import type { helpersIsArchiveWallArticle$key } from "scmp-app/queries/__generated__/helpersIsArchiveWallArticle.graphql";
import type { helpersIsLiteWallArticle$key } from "scmp-app/queries/__generated__/helpersIsLiteWallArticle.graphql";
import type { helpersIsVelocityWallArticle$key } from "scmp-app/queries/__generated__/helpersIsVelocityWallArticle.graphql";

export const checkArticleIsInLiteUpgradeWall = (
  article_: helpersIsLiteWallArticle$key,
  isLiteUser: boolean,
  liteArticleTimeFrame: number,
) => {
  const article = readInlineData(
    graphql`
      fragment helpersIsLiteWallArticle on Article @inline {
        createdDate
        publishedDate
      }
    `,
    article_,
  );

  const isLiteArticleDate = Date.now() - 1000 * 60 * 60 * 24 * liteArticleTimeFrame;
  const articleDate = notEmpty(article.publishedDate) ? article.publishedDate : article.createdDate;

  return isLiteUser && !!articleDate && isLiteArticleDate > articleDate;
};

export const checkArticleIsInArchiveWall = (
  article_: helpersIsArchiveWallArticle$key,
  archiveArticleTimeFrame: number,
) => {
  const article = readInlineData(
    graphql`
      fragment helpersIsArchiveWallArticle on Article @inline {
        ...helpersIsVelocityWallArticle
        createdDate
        publishedDate
        paywallTypes {
          entityId
        }
      }
    `,
    article_,
  );
  const isArchivedArticleDate = Date.now() - 1000 * 60 * 60 * 24 * archiveArticleTimeFrame;
  const articleDate = notEmpty(article.publishedDate) ? article.publishedDate : article.createdDate;
  // If either date is empty, it should not in archive wall
  if (!notEmpty(isArchivedArticleDate) || !notEmpty(articleDate)) return false;

  const paywallTypesHasNotArchived = notEmpty(
    article.paywallTypes?.find?.(
      paywallType => paywallType?.entityId === paywall.notArchive.entityId,
    ),
  );

  const isInVelocityWall = checkArticleIsInVelocityWall(article);
  return !paywallTypesHasNotArchived && !isInVelocityWall && isArchivedArticleDate > articleDate;
};

export const checkArticleIsInVelocityWall = (article_: helpersIsVelocityWallArticle$key) => {
  const article = readInlineData(
    graphql`
      fragment helpersIsVelocityWallArticle on Article @inline {
        paywallTypes {
          entityId
        }
      }
    `,
    article_,
  );
  const paywallTypesHasNotVelocity = notEmpty(
    article.paywallTypes?.find?.(
      paywallType => paywallType?.entityId === paywall.notVelocity.entityId,
    ),
  );

  const paywallTypesHasVelocity = notEmpty(
    article.paywallTypes?.find?.(
      paywallType => paywallType?.entityId === paywall.velocity.entityId,
    ),
  );

  return !paywallTypesHasNotVelocity && paywallTypesHasVelocity;
};
